import { render, staticRenderFns } from "./kehuzhongxin.vue?vue&type=template&id=514ed1b6&"
import script from "./kehuzhongxin.vue?vue&type=script&lang=js&"
export * from "./kehuzhongxin.vue?vue&type=script&lang=js&"
import style0 from "./kehuzhongxin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports